/**
 * Logs hook — v1 MVP uses HTTP polling, not WS streaming.
 *
 * The returned callback is pluggable into <LogViewer onFetchLogs={...}/>,
 * which owns the xterm instance and decides how to diff incoming lines
 * against what's already in the scrollback buffer.
 *
 * TODO: once the multiplexed WS bus ships, swap this for a subscription
 * to `logs:<agent>` and keep a thin HTTP seeder for the initial backfill.
 */
import { useCallback } from 'react';
import { logsApi, type LogTailResponse } from '@/api/logs';

export function useLogs(agent: string | undefined) {
  const fetchLogs = useCallback(
    async (tail = 1000): Promise<LogTailResponse | null> => {
      if (!agent) return null;
      return logsApi.tail(agent, { tail });
    },
    [agent]
  );

  const downloadUrl = agent ? logsApi.downloadUrl(agent) : '';

  return { fetchLogs, downloadUrl };
}
